export const SURVEY_STATUS = Object.freeze({
   DRAFT: 'draft' as const,
   OPEN: 'open' as const,
   CLOSED: 'closed' as const,
   PAUSED: 'paused' as const,
});

export type SurveyStatus =
   | typeof SURVEY_STATUS.DRAFT
   | typeof SURVEY_STATUS.OPEN
   | typeof SURVEY_STATUS.CLOSED
   | typeof SURVEY_STATUS.PAUSED;

export const ENV_TYPE = Object.freeze({
   LOCAL: 'LOCAL',
   DEVELOPMENT: 'DEVELOPMENT',
   PRODUCTION: 'PRODUCTION',
});

export const AVAILABLE_STATUSES_BY_LABEL: Record<SurveyStatus, SurveyStatus[]> =
   {
      draft: ['open', 'closed', 'paused'],
      open: ['paused', 'closed'],
      paused: ['open', 'closed'],
      closed: ['open', 'paused'],
   };
